import { ENVIRONMENT } from '../constants';
import getEnvVariable from './environment';

export const redirectToMako = () => window.location.replace(getEnvVariable(ENVIRONMENT.MAKO_HOST_URL));